
<!-- El video ahora se renderiza siempre para que pueda iniciar la carga, 
     pero se oculta o muestra con una clase CSS. -->
<video
  #videoPlayer
  playsinline
  autoplay
  loop
  muted
  [src]="videoSrc()"
  [class.visible]="status() === 'loaded'"
  [attr.width]="width()"
  [attr.height]="height()"
  [class]="cssClass()"
  [attr.alt]="alt()"
  (loadeddata)="onVideoLoaded()"
  (error)="onVideoError($event)"
  loading="lazy"
  
></video>

<!-- El loader se muestra solo durante el estado de carga -->
@if (status() === 'loading') {
  <span> </span>
}

<!-- El fallback se muestra solo en caso de error -->
@if (status() === 'error') {
  @if (fallbackSrc(); as fallback) {
    <img [src]="fallback" [alt]="alt()" [width]="width()" [height]="height()" [class]="cssClass()" />
  } @else {
    <div class="fallback-text">No se pudo cargar el video.</div>
  }
}
